import React, { forwardRef } from "react"

export const NavColorWaypoint = forwardRef((props, ref) => <span ref={ref} />)
